import * as React from 'react';
import { ReactNode } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getUniversalActionMessageMaxLimit } from '../../service/gridItemsActionsHelpers/gridItemsActionsHelpers';
import { GridViewType } from '../../typings/grid';
import { ScopedTooltip } from '../TooltipDecorator/ScopedTooltip';

import './WarningMaxLimitTooltip.css';

export interface WarningMaxLimitTooltipProps {
    visible: boolean;
    sourceParamsView: GridViewType;
    totalCount: number;
    refParent: ReactNode | null;
    onOutsideClick(): void;
}

export class WarningMaxLimitTooltip extends React.PureComponent<WarningMaxLimitTooltipProps> {
    render() {
        const { totalCount, sourceParamsView, refParent, onOutsideClick, visible } = this.props;

        if (!refParent) {
            return null;
        }

        return (
            <ScopedTooltip
                anchor={refParent}
                theme="white"
                scope={this.getScopeForTooltip}
                view="classic"
                tone="default"
                to="right"
                size="m"
                visible={visible}
                autoclosable={true}
                cls={Bem.cls('warning-max-limit-tooltip', 'tooltip-max-limit')}
                onOutsideClick={onOutsideClick}
            >
                <div className={Bem.cls('warning-max-limit-tooltip', 'tooltip-content')}>
                    {getUniversalActionMessageMaxLimit(sourceParamsView, totalCount)}
                </div>
            </ScopedTooltip>
        );
    }

    // прикрепляем тултип к common-grid-screen__body, чтобы скролл не влиял на него
    private getScopeForTooltip(): HTMLElement {
        return document.getElementsByClassName('common-grid-screen__body')[0] as HTMLElement;
    }
}
